import React from "react";
import {
  Button,
  Box,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Input,
  LinearProgress,
} from "@material-ui/core";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";
import PropTypes from "prop-types";

import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import saveAs from "file-saver";

export default function ImageZipDl(props) {
  const defaultLastPage = props.manifest.json.sequences[0].canvases.length;
  const defaultFirstPage = 1;

  const [disable, setDisable] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [firstPage, setFirstPage] = React.useState(1);
  const [lastPage, setLastPage] = React.useState(defaultLastPage);
  const [progress, setProgress] = React.useState(0);

  const handleFirstPage = (e) => {
    setFirstPage(e.target.value);
  };
  const handleLastPage = (e) => {
    setLastPage(e.target.value);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setLastPage(defaultLastPage);
    setDisable(false);
    setProgress(0);
    setFirstPage(defaultFirstPage);
    setLastPage(defaultLastPage);
  };

  const minmax = (value, min, max) => {
    if (parseInt(value) < min || isNaN(value)) return min;
    //falls der wert kleiner ist als min gib min zurück
    else if (parseInt(value) > max) return max;
    // falls der wert größer ist als max gib max zurück
    else return value; //ansonsten geht alles klar
  };

  const getZip = () => {
    setDisable(true);
    const zip = new JSZip();
    const urls = [];

    //todo find a better way to get the adress for image
    for (let i = firstPage; i <= lastPage; i++) {
      urls.push(
        props.manifest.json.sequences[0].canvases[i - 1].images[0].resource
          .service["@id"] +
          "/full/" +
          props.manifest.json.sequences[0].canvases[i - 1].width +
          ",/0/default.jpg"
      );
    }

    let count = 0;
    let count2 = 0;
    const zipFileName = props.manifest.json.label + ".zip";
    const nameFromUrl = [];

    for (let i = 0; i < urls.length; i++) {
      const the_arr = urls[i].split("/")[8].split(".")[0];
      nameFromUrl[i] = the_arr + ".jpg";
    }

    urls.forEach(function (url) {
      let filename = nameFromUrl[count2];
      count2++;
      JSZipUtils.getBinaryContent(url, function (err, data) {
        if (err) {
          throw err;
        }
        //add every img to zip
        zip.file(filename, data, { binary: true });
        count++;
        setProgress(normalise(count - 1));
        //if every img is added to zip create dl
        if (count == urls.length) {
          zip.generateAsync({ type: "blob" }).then(function (content) {
            saveAs(content, zipFileName);
            setProgress(100);
          });
        }
      });
    });
  };

  const zipCreate = () => {
    if (progress == 100) {
      return "Zip " + props.t("dlFinish");
    } else if (progress >= 1) {
      return "Zip " + props.t("dlCreate");
    } else {
      return "";
    }
  };


  const normalise = (value) =>
    ((value - firstPage) * 100) / (lastPage - firstPage);

  return (
    <Box mb={1} ml={1}>
      <Button
        variant="contained"
        startIcon={<GetAppOutlinedIcon fontSize="small" />}
        onClick={handleOpen}
      >
        {" "}
        Zip{" "}
      </Button>
      <Dialog fullWidth={false} maxWidth={'xs'} onClose={handleClose} open={open}>
        <DialogTitle onClose={handleClose}>
          <Typography variant="h2">
            {props.t("downloadZipMenu")}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography fontWeight="fontWeightBold">
            {" "}
            {props.t("zipText")}{" "}
          </Typography>
          <Card>
            <Box ml={2} mt={2} mb={2}>
              {/* Input Pages */}
              <Typography fontWeight="fontWeightBold">
                {props.t("pages")}:{" "}
              </Typography>
              <Input
                className="input"
                type="number"
                inputProps={{
                  min: defaultFirstPage,
                  max: lastPage,
                }}
                placeholder={"1"}
                onChange={handleFirstPage}
                onKeyUp={(e) => {
                  e.target.value = minmax(
                    e.target.value,
                    defaultFirstPage,
                    lastPage
                  );
                  handleFirstPage(e);
                }}
                disabled={disable}
                defaultValue={defaultFirstPage}
              />
              <Input
                className="input"
                type="number"
                inputProps={{
                  min: firstPage,
                  max: defaultLastPage,
                }}
                placeholder={defaultLastPage.toString()}
                onChange={handleLastPage}
                onKeyUp={(e) => {
                  e.target.value = minmax(
                    e.target.value,
                    firstPage,
                    defaultLastPage
                  );
                  handleLastPage(e);
                }}
                defaultValue={defaultLastPage}
                disabled={disable}
              />
            </Box>
          </Card>
          {/* download btn for zip */}
          <Box mt={1} mb={1}>
            <Button
              variant="contained"
              startIcon={<GetAppOutlinedIcon fontSize="small" />}
              disabled={disable}
              onClick={() => getZip()}
            >
              {props.t("download")} Zip
            </Button>
          </Box>
          <LinearProgress
            variant="determinate"
            value={progress}
          ></LinearProgress>
          {progress >= 1 && (
            <Typography fontSize={5}>
              {Math.round(progress)} % {" " + "-" + " "}
              {zipCreate()}
            </Typography>
      )}
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleClose}>
            {props.t("back")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

ImageZipDl.propTypes = {
  defaultLastPage: PropTypes.number,
  defaultFirstPage: PropTypes.number,
  firstPage: PropTypes.number,
  lastPage: PropTypes.number,
  progress: PropTypes.number,
  open: PropTypes.bool,
};